import { useDispatch } from "react-redux";

import { sendClickToSellHomepageEvent } from "../../actions";
import { useAgentMatchData } from "../agentMatchHooks";

export const useAnalyticsBehavior = () => {
  const dispatch = useDispatch();
  const { contactId, propertyId, uuid } = useAgentMatchData();

  return {
    sendClickToSellHomepageEvent: () =>
      dispatch(
        sendClickToSellHomepageEvent({
          expertContactId: contactId,
          propertyId,
          uuid
        })
      )
  };
};
